<template>
  <div class="table-card card">
    <h2 class="table-title">Registered Studies</h2>
    <div v-if="isLoading" class="flex justify-center mt-5">
      <loading />
    </div>
    <alt-table
      v-else
      :columns="columns"
      pagination
      :paginationOptions="paginationOptions"
      @onPagination="$emit('onPagination', $event)"
    >
      <template #t-row>
        <tr v-for="(s, index) in studies" :key="s.id">
          <td>{{ index + 1 }}</td>
          <td class="text-center">{{ s.identifier }}</td>
          <td class="text-center">{{ s.name }}</td>
          <td class="text-center">
            <span class="bg-success badge" v-if="s.isActive">Active</span>
            <span class="bg-danger badge" v-else>Inactive</span>
          </td>
          <td class="actions">
            <button class="btn-action" @click="$emit('edit', s)">✏️</button>
            <button class="btn-active-inactive" @click="changeTitleModalAndOpenModal(s)">
              {{ s.isActive ? 'Deactivate' : 'Activate' }}
            </button>
          </td>
        </tr>
      </template>
    </alt-table>
  </div>
  <ModalConfirm
    v-model:visible="showModal"
    :title="titleModal"
    @confirm="executeActiveOrInactive"
  />
</template>

<script setup>
import { ref } from 'vue';
import AltTable from '@/components/tables/altTable.vue';
import Loading from '@/components/loading.vue';
import ModalConfirm from '@/components/ModalConfirm.vue';
const props = defineProps({
  studies: Array,
  paginationOptions: Object,
  isLoading: {
    type: Boolean,
    default: false,
  },
  columns: {
    type: Array,
    default: () => [
      { header: 'N°' },
      { header: 'Identifier' },
      { header: 'Name' },
      { header: 'Status' },
      { header: 'Actions' },
    ],
  },
});

const titleModal = ref('');
const studySelected = ref(null);
const showModal = ref(false);

const emit = defineEmits(['onPagination', 'edit', 'delete', 'edit-active-inactive']);

const changeTitleModalAndOpenModal = (study) => {
  studySelected.value = study;
  showModal.value = true;
  titleModal.value = `Are you sure you want to ${study.isActive ? 'deactivate' : 'activate'} this study?`;
};
const executeActiveOrInactive = async () => {
  emit('editActiveInactive', {
    ...studySelected.value,
    isActive: !studySelected.value.isActive,
  });
};
</script>

<style scoped lang="scss">
.table-card {
  padding: 1.5rem;
  border-radius: 8px;
  .table-title {
    text-align: center;
    color: var(--primary-color);
    margin-bottom: 1rem;
  }
  .actions {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    .btn-action {
      background: none;
      border: none;
      cursor: pointer;
      font-size: 1.1rem;
      transition: transform 0.2s;
      &:hover {
        transform: scale(1.2);
      }
    }
  }
}

.badge {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  border-radius: 0.25rem;
}

.btn-active-inactive {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  border-radius: 0.25rem;
  background-color: transparent;
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
  cursor: pointer;
  transition: 0.5s all;
  &:hover {
    background-color: var(--primary-color);
    color: #fff;
  }
}
</style>
